import { getSessionCookie } from "../helpers/cookies.js";
import { api_GET, api_POST, api_POST_FORM } from "./_api.js";

const analiseInfracao_api = {
    getListAcoesInternas: (infracao_id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`AnaliseInfracao/GetOpcoesAnaliseInterna/${infracao_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListAcoesExternas: (hash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`AnaliseInfracao/GetOpcoesAnaliseExterna/${hash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostFiscalizacaoInfracaoAcao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("AnaliseInfracao/PostFiscalizacaoInfracaoAcao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostFiscalizacaoInfracaoAcaoForm: (formData) => {
        const promise = new Promise((resolve, reject) => {
            api_POST_FORM("AnaliseInfracao/PostFiscalizacaoInfracaoAcaoForm/", formData)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ReenviarEmailInfracao: (infracao_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`AnaliseInfracao/ReenviarEmailInfracao/${infracao_Id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetConsultarCobranca: (fiscalizacaoInfracaoBoleto_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`AnaliseInfracao/GetConsultarCobranca/${fiscalizacaoInfracaoBoleto_Id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    CancelarInfracao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("AnaliseInfracao/CancelarInfracao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetSolicitarBoleto: (fiscalizacaoInfracao_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`AnaliseInfracao/SolicitarBoleto/${fiscalizacaoInfracao_Id}/`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetSolicitarBoletoPng: (fiscalizacaoInfracao_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`AnaliseInfracao/SolicitarBoletoPng/${fiscalizacaoInfracao_Id}/`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ResetInfracao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("AnaliseInfracao/ResetInfracao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    // Busca os dados de backup (DTO completo da ficha) para um reset específico
    GetResetFicha: (resetId) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`AnaliseInfracao/GetResetFicha/${resetId}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default analiseInfracao_api;
